import styled from "styled-components";
import { HiOutlineUser, HiOutlineBuildingOffice2 } from "react-icons/hi2";

/**
 * Individual / entity indicator for list rows and cards. A slim outline icon
 * (matching the All / Individual / Entity tab icons) inside a subtle light-grey
 * circular chip, so a row's subject type reads at a glance. Person icon for an
 * individual, building icon for an entity.
 */
interface SubjectTypeIconProps {
  isEntity: boolean;
  /** Chip diameter in px (default 30). Icon scales to ~55%. */
  size?: number;
}

const Chip = styled.span<{ diameter: number }>`
  ${({ theme: { colors }, diameter }) => `
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    width: ${diameter}px;
    height: ${diameter}px;
    border-radius: 50%;
    background: ${colors.gray[10]};
    border: 1px solid ${colors.gray[100]};
    color: ${colors.gray[60]};
  `}
`;

export const SubjectTypeIcon = ({ isEntity, size = 30 }: SubjectTypeIconProps) => {
  const iconSize = Math.round(size * 0.55);
  const label = isEntity ? "Entity" : "Individual";
  return (
    <Chip diameter={size} title={label} aria-label={label}>
      {isEntity ? (
        <HiOutlineBuildingOffice2 size={iconSize} />
      ) : (
        <HiOutlineUser size={iconSize} />
      )}
    </Chip>
  );
};
